import React from 'react'
import PropTypes from 'prop-types'

import { Logger, LoggerTypes } from '../../../utils'
import './style.scss'

export const ScenarioConsole = ({ project, isLoading }) => {
  Logger.trace(LoggerTypes.CONTAINER, 'ScenarioConsole.render()', { isLoading, project })

  return (
    <div className="content_scene__side_right">
      <div className="simulation_console">
        <div className="under_construction" />
      </div>
    </div>
  )
}

ScenarioConsole.displayName = 'ScenarioConsole'

ScenarioConsole.propTypes = {
  project: PropTypes.object,
  isLoading: PropTypes.bool
}

ScenarioConsole.defaultProps = {
  project: null,
  isLoading: true
}
